<template>
  <div class="indexDetail2">
    <!-- 可替换banner 对应后台产品图片字段-->
    <section class="banner inner-banner">
      <img
        :src="list.bannerImg"
      />
    </section>
    <!-- 可替换banner 对应后台产品图片字段-->
    <div class="content-edit" v-html="wcjrDetail"></div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  metaInfo() {
    return {
      title: "三维超声腹部导航手术机器人-健新",
      meta: [
        { name: "keywords", content: "keyword1, keyword2, keyword3" },
        { name: "description", content: "Page description" },
      ],
    };
  },
  mounted() {
    // const element = getScrollParent(this.$el)
    // element.scrollTop = 0
  },
  data() {
    return {
      wcjrDetail: "",
      list:{}
    };
  },
  created() {
    this.getBanner()
    let data = {
        Title: this.$route.query.title,
        ForumTypeCode:'JXWCJR'
      }
    this.getQWcjrList(data)
  },
  methods: {
    getBanner() {
      let data = {
        Title: this.$route.query.title + "Banner图",
        ForumTypeCode: "JXWCJR",
      };
      axios
        .post("api/Forum/GetDoc", { ...data })
        .then((res) => {
          if (res) {
            this.list = JSON.parse(res.data.OutputData.Content);
          } else {
            this.$message({
              type: "error",
              message: "请求数据失败",
            });
          }
        });
    },
    getQWcjrList(data) {
      axios
        .post("api/Forum/GetDoc", { ...data })
        .then((res) => {
          if (res) {
            this.wcjrDetail = res.data.OutputData.Content
          } else {
            this.$message({
              type: "error",
              message: "请求数据失败",
            });
          }
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='less'>
@import "../../assets/less/base.less";
@import "../../assets/less/common.less";

.indexDetail2 {
  .banner {
    img {
      max-width: auto;
      min-width: 100%;
      height: auto;
      min-height: 100%;
    }
  }
  .content-edit {
    .article-width {
      margin: 0 auto;
      .heart-line {
        justify-content: center;
      }
      .heart-line:before {
        background-image: url(http://desktop.bofangmedical.com:10780/static/images/article-title-left.png); // background-image: url(../../assets/images/article-title-left.png);
      }
      .heart-line:after {
        background-image: url(http://desktop.bofangmedical.com:10780/static/images/article-title-right.png); // background-image: url(../../assets/images/article-title-right.png);
      }
      .heart-line:before,
      .heart-line:after {
        content: "";
        display: block;
        background-size: 100% auto;
        background-position: center;
        background-repeat: no-repeat;
      }

      .article-title {
        display: flex;
        align-items: center;
        line-height: 1.2;
        color: black;
        font-weight: normal;
      }

      .article-para {
        line-height: 1.5;
        text-indent: 2em;
        color: black;
        text-align: justify;
        font-weight: lighter;
      }

      .img-center {
        margin: 1.5em auto;
      }

      .article-img {
        max-width: 100%;
        height: auto;
        display: block;
        font-size: 1em;
        border: none;
        outline-width: 0px;
        vertical-align: top;
      }
    }
  }
  @media only screen and (min-width: 960px) {
    .banner {
      padding-top: 130px;
    }
    .content-edit {
      margin-bottom: 60px;
      .article-width {
        max-width: 1160px;
        .article-title {
          font-size: 54px;
          padding: 80px 0;
        }
        .heart-line:before,
        .heart-line:after {
          width: 139px;
          height: 36px;
          margin: 0 10px;
        }

        .article-para {
          font-size: 24px;
        }
      }
    }
  }
  @media screen and (max-width: 1199px) and (min-width: 960px) {
    .article-width {
      max-width: 96% !important;
    }
  }
  @media screen and (max-width: 1024px) and (min-width: 960px) {
    .article-title {
      font-size: 1.8rem;
      padding: 2.16rem 0;
      .heart-line:before,
      .heart-line:after {
        content: "";
        display: block;
        width: 2.651rem;
        height: 3rem;
        margin: 0 0.36em;
      }
    }
    .article-para {
      font-size: 1.28rem;
    }
  }
  @media screen and (max-width: 960px) and (min-width: 320px) {
    .banner {
      padding-top: 3.52rem;
    }
    .content-edit {
      margin-bottom: 2.4rem;
      .article-width {
        max-width: 96%;
        .article-title {
          font-size: 1.8rem;
          padding: 2.16rem 0;
        }
        .article-para {
          font-size: 1.28rem;
        }
      }
    }
  }
}
</style>